import dayjs from 'dayjs'
import {
  getFICOCreditScore,
  uploadCRSReport,
  uploadCriminalReport,
  uploadEvictionReport
} from 'API/houseApplication/crs'
import {
  IApplicationFormValues,
  ICRSCreditScoreResponse,
  ICRSCriminalTenantData,
  ICRSEvictionTenantData,
  ICRSTenantData
} from 'interfaces/application'
import {
  TEST_CRS_EMAIL_SUB,
  TEST_CRS_CREDIT_SCORE_MOCK_DATA,
  TEST_CRS_CRIMINAL_MOCK_DATA,
  TEST_CRS_EVICTION_MOCK_DATA
} from '../constant'

export async function fetchCreditScore(formValue: IApplicationFormValues): Promise<ICRSCreditScoreResponse> {
  const isTestingCRS: boolean | undefined = formValue?.email?.includes(TEST_CRS_EMAIL_SUB)
  let tenantData: ICRSTenantData = {} as ICRSTenantData

  if (isTestingCRS) {
    tenantData = TEST_CRS_CREDIT_SCORE_MOCK_DATA
  } else {
    tenantData = {
      firstName: formValue?.firstName ?? '',
      lastName: formValue?.lastName ?? '',
      dob: dayjs(formValue?.dateOfBirth).format('YYYY-MM-DD'),
      ssn: formValue?.ssn?.replaceAll('-', ''),
      phone: formValue?.phoneNumber
    }
  }
  const creditScoreResponse: ICRSCreditScoreResponse = await getFICOCreditScore(tenantData)

  return creditScoreResponse
}

export async function getCreditScore(formValue: IApplicationFormValues): Promise<number> {
  const creditScoreResponse: ICRSCreditScoreResponse = await fetchCreditScore(formValue)
  const { score, pdfReportId } = creditScoreResponse
  if (pdfReportId && formValue?.phoneNumber && formValue?.buildiumUnitId) {
    uploadCRSReport(pdfReportId, formValue.phoneNumber, formValue.buildiumUnitId)
  }

  return score
}

export async function handleUploadCriminalReport(formValue: IApplicationFormValues): Promise<void> {
  const isTestingCRS: boolean | undefined = formValue?.email?.includes(TEST_CRS_EMAIL_SUB)
  let tenantData: ICRSCriminalTenantData = {} as ICRSCriminalTenantData

  if (isTestingCRS) {
    tenantData = TEST_CRS_CRIMINAL_MOCK_DATA
  } else {
    tenantData = {
      first: formValue?.firstName ?? '',
      last: formValue?.lastName ?? '',
      city: formValue?.city ?? '',
      state: formValue?.state ?? '',
      dob: dayjs(formValue?.dateOfBirth).format('MM-DD-YYYY'),
      ssn: formValue?.ssn?.replaceAll('-', ''),
      zip: formValue?.zipCode
    }
  }

  if (formValue?.phoneNumber && formValue?.buildiumUnitId) {
    await uploadCriminalReport(formValue?.phoneNumber, formValue?.buildiumUnitId, tenantData)
  }
}

export async function handleUploadEvectionReport(formValue: IApplicationFormValues): Promise<void> {
  const isTestingCRS: boolean | undefined = formValue?.email?.includes(TEST_CRS_EMAIL_SUB)
  let tenantData: ICRSEvictionTenantData = {} as ICRSEvictionTenantData

  if (isTestingCRS) {
    tenantData = TEST_CRS_EVICTION_MOCK_DATA
  } else {
    tenantData = {
      first: formValue?.firstName ?? '',
      last: formValue?.lastName ?? '',
      city: formValue?.city ?? '',
      state: formValue?.state ?? '',
      dob: dayjs(formValue?.dateOfBirth).format('MM-DD-YYYY'),
      ssn: formValue?.ssn?.replaceAll('-', ''),
      zip: formValue?.zipCode,
      streetName: formValue?.streetName ?? '',
      houseNumber: formValue?.houseNumber ?? ''
    }
  }

  if (formValue?.phoneNumber && formValue?.buildiumUnitId && tenantData?.city && tenantData?.state) {
    await uploadEvictionReport(formValue?.phoneNumber, formValue?.buildiumUnitId, tenantData)
  }
}
